export const SearchAndCoursesConstants = {
  FEATURE_TOGGLE_NAME: 'reg-standalone_scheduler'
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/constants/search_and_add_courses_constants.ts